var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostSearchResultList',{staticClass:"background-result-list",attrs:{"posts":_vm.posts,"columns":3},on:{"clicked":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }